import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast, ToastOptions } from "react-toastify";
import { ToggleShowGeneralToast } from "../redux/slices/generalToastSlice"; // Assuming this action toggles the toast visibility
import {
  BASE_LOCAL_IMAGES_DIR,
  GlobalToasterDuration,
} from "../utils/constants/CommonConstants";
import {
  error_toast_rounded_blur_IMG,
  success_toast_rounded_blur_IMG,
} from "../utils/constants/Images";

const useToast = () => {
  const dispatch = useDispatch();

  const showToast = useCallback(
    (
      message: string,
      description: string = "",
      type: "success" | "error" | "info" | "warning",
      duration: number = 5000,
      position: ToastOptions["position"] = "bottom-right",
      imgSrc?: string | null,
      disableCancel?: boolean,
    ) => {
      const ToastContent = (
        <div className="relative flex items-center gap-0.5 rounded-lg shadow-z16">
          {type === "success" ? (
            <img
              src={`${BASE_LOCAL_IMAGES_DIR}/${success_toast_rounded_blur_IMG}`}
              alt="Success"
              loading="lazy"
              className="absolute -left-20 -top-5 h-28 w-full"
            />
          ) : null}
          {type === "error" ? (
            <img
              src={`${BASE_LOCAL_IMAGES_DIR}/${error_toast_rounded_blur_IMG}`}
              alt="Error"
              loading="lazy"
              className="absolute -left-20 -top-5 h-28 w-full"
            />
          ) : null}
          {imgSrc && (
            <div className="mr-2">
              <img
                src={imgSrc}
                loading="lazy"
                alt="Toast-Icon"
                className="h-10 w-10"
              />
            </div>
          )}
          <div>
            <strong className="text-base font-bold text-headingTextColor">
              {message}
            </strong>
            <p className="text-sm font-normal text-bodyTextColor">
              {description}
            </p>
          </div>
        </div>
      );

      if (type in toast) {
        (toast[type] as any)(ToastContent, {
          position,
          autoClose: duration,
          closeButton: disableCancel ? false : undefined,
        });

        setTimeout(() => {
          ToggleShowGeneralToast({
            ToasterContent: {
              title: "",
              desc: "",
              duration: GlobalToasterDuration,
              position: "bottom-right",
              type: "success",
              img: "",
            },
          });
        }, duration);
      } else {
        console.error(`Toast type ${type} is not supported.`);
      }
    },
    [dispatch],
  );

  return { showToast };
};

export default useToast;
